import appAPI from '../../api/app'

const state = {
  initialFlag: false, //  app initialization
  contact_notifications: [],
  countries: []
}

const actions = {
  initialData ({commit}, promises) {
    Promise.all(promises).then(() => {
      commit('setInitialFlag', true)
    }, () => {
      commit('setInitialFlag', false)
    })
  },
  getNotificationsData ({commit}) {
    appAPI.getContactNotifications().then((response) => {
      commit('setContactNotifications', response)
    })
  },
  getCountries ({commit}) {
    appAPI.getCountries().then((response) => {
      commit('setCountries', response)
    })
  }
}

const mutations = {
  setInitialFlag (state, flag) {
    state.initialFlag = flag
  },
  setCountries (state, countries) {
    state.countries = countries
  },
  setContactNotifications (state, notifications) {
    state.contact_notifications = notifications
  }
}

const getters = {
  initialFlag (state) {
    return state.initialFlag
  },
  getCountries (state) {
    return state.countries
  },
  getContactNotifications (state) {
    return state.contact_notifications
  }
}

export default {
  getters,
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/app.js